import { BaseTemplateTask } from "./basetemplatetask";
import { ChangeTracked, Community, Note } from "./index";
import { TaskCategory } from "./taskcategory";
import { TemplateTask } from "./templatetask";

export class Template {
    //base properties
    templateId: number;
    planId: number;
    isActive: boolean;
    isPendingRemoval: boolean;
    communityId: number;
    templateName: string;
    description: string;
    taskCategoryId: number;
    noteId?: number;

    //navigation properties
    community: Community;
    taskCategory: TaskCategory;
    note: Note;
    templateTasks?: TemplateTask[] & ChangeTracked<TemplateTask[]>;

    //non-base properties
    planName: string;
    planNumber: string;
    isRTP: boolean;
    isRTC: boolean;  
    productType: string;
    taskCount: number;
    totalDuration: number;
    scarStartToFinal: number;
    hasAllScarStages: boolean;
    marketId: number;
    templateBaseTasks?: BaseTemplateTask[] & ChangeTracked<BaseTemplateTask[]>;
}

export class BaseTemplate extends Template {
    notes: string;
    description: string;
}
